/* eslint-disable */
import {ReactComponent} from './ReactComponent';
import {EditorialMenu} from './EditorialMenu';
import {EditorialLink} from './EditorialLink';
import {BasePageModel} from './BasePageModel';
/**
* @description Interface for Avensia.Commerce.Web.src.views.EditorialPage.EditorialPageModel
*/
export interface EditorialPageModel extends BasePageModel {
	content: ReactComponent[];
	totalCount: number;
	menu: EditorialMenu[];
	editorials: EditorialLink[];
	group: string;
	articleFilter: string;
	nextPage: number;
}
export const isEditorialPage = (model: unknown): model is EditorialPageModel => (model as EditorialPageModel).componentName === 'EditorialPage';
